import $ from 'jquery';
import m from "../../prime-src/prepare";
import { useEffect, useState } from 'react';

// 새로운 CatList 컴포넌트 생성
export function CatList({ catList, fsGotoCats }) {
	if (!catList || catList.length === 0) return null;

	// 하위 카테고리 렌더링을 위한 재귀적 함수
	const renderSubCategories = (items, depth) => {
		return items.map((item) => {
			const cat = item.cat;
			const hasSubCats = catList.some(c =>
				c.depth === depth + 1 && m.getSuperCat(c.cat) === cat
			);

			const subCatItems = hasSubCats ?
				catList.filter(c => m.getSuperCat(c.cat) === cat) : [];

			return (
				<div key={cat}>
					<div
						id={`cat-${encodeURIComponent(cat)}`}
						className={`cat${fsGotoCats?.fullList[cat]?.selected ? " selected" : ""}`}
						style={{marginLeft: `${depth}em`}}
					>
						{hasSubCats ? (
							<span
								className="EC"
								onClick={(e) => m.ExpCol(e.target as HTMLElement)}
							>
								{item.subCatExpanded ? "▼" : "▶"}
							</span>
						) : (
							<span className="noEC"></span>
						)}
						<a className={`baseCat${fsGotoCats?.fullList[cat]?.down ? " down" : ""}`}>
							<span className="list-index-id">{cat}</span>
							{item.baseCat}
						</a>
					</div>
					{hasSubCats && (
						<div
							className="subCat"
							style={{display: item.subCatExpanded ? "block" : "none"}}
						>
							{renderSubCategories(subCatItems, depth + 1)}
						</div>
					)}
				</div>
			);
		});
	};

	// 최상위 카테고리와 하위 카테고리 렌더링
	return (
		<div>
			{renderSubCategories(catList.filter(item => item.depth === 0), 0)}
		</div>
	);
}

export default function Sidebar({ myCatList, setMyCatList, userCatList, setUserCatList, opened, setOpened, isChangingOrder, setIsChangingOrder }) {
	const [catList, setCatList] = useState([]);

	useEffect(() => {
		m.ExpCol = (elem) => {
			const $elem = $(elem);
			const $baseCat = $elem.next(".baseCat");
			const cat = $baseCat.find(".list-index-id").text();
			const $next = $elem.parent().next();

			if ($next.is(":visible")) {
				$next.hide();
				$elem.html("▶");
				if (m.catList[cat]) {
					m.catList[cat].subCatExpanded = false;
					setCatList([...m.catList]);
				}
			} else {
				$next.show();
				$elem.html("▼");
				if (m.catList[cat]) {
					m.catList[cat].subCatExpanded = true;
					setCatList([...m.catList]);
				}
			}
		};

		m.$change_catList_order = $("#change-catList-order");
		m.$change_catList_order_ok = $("#change-catList-order-ok");
		m.$change_catList_order_cancel = $("#change-catList-order-cancel");

		m.handleChangeCat = (e) => {
			try {
				m.triggerOpenCat(e);
			} catch (err) {
				// ! clicking blank space is normal activities.
			}
			return false;
		};

		//////////////////////////////////////
		// CatList order
		//////////////////////////////////////
		m.$change_catList_order.on("click.change-order-catList", function (e) {
			// 스크롤 위치 저장
			m.savedSidebarScrollTop = m.$sidebar.scrollTop();

			setIsChangingOrder(true);
			let $cats = m.$catList.find(".cat").not(`#cat-`);
			$cats.parent().addClass("edit");
			$cats.prepend('<div class="edit-bar"></div>');
			$cats.append('<div class="edit-bar"></div>');
			m.$catList.find(".edit-bar").on("mousedown.order-change touchstart.order-change", function (e: Event) {
				e.preventDefault();
				e.stopPropagation();
				let $catM = $(this);
				if (!$catM.hasClass("edit")) {
					$catM = $catM.closest(".edit");
					// cat-moving
				}
				let $catSiblings = $catM.siblings(".edit");
				if ($catSiblings.length) {
					let touch0 = e.type === "touchstart" ? (e as TouchEvent).touches[0] : (e as MouseEvent);
					let relativeX = touch0.clientX - Math.round($catM.offset().left) + m.$window.scrollLeft();
					let relativeY = touch0.clientY - Math.round($catM.offset().top) + m.$window.scrollTop();
					let $lastSibling = $catSiblings.last();
					$catM.children(".cat").css({ width: $catM.children(".cat").outerWidth() });
					$catM.addClass("move");
					let cat = decodeURIComponent(m.unescapeEncodePctg($catM.children(".cat").attr("id").substring(4)));
					let $catTo = $(
						`<div id="cat-to-here" style="margin-left:${m.catList[cat].depth + 0.5}em"></div>`
					);
					$catM.before($catTo);
					let catTo = -2;
					m.$html.on("mousemove.mdInEB touchmove.mdInEB", function (e: Event) {
						window.getSelection().removeAllRanges();
						e.preventDefault();
						e.stopPropagation();
						let touch0 = e.type === "touchmove" ? (e as TouchEvent).touches[0] : (e as MouseEvent);
						$catM.css({
							left: touch0.clientX - relativeX,
							top: touch0.clientY - relativeY,
						});
						let wST = m.$window.scrollTop();
						let sidebarTop = m.$sidebar.offset().top - wST;
						let sidebarBottom = sidebarTop + m.$sidebar.outerHeight();
						let scrollPad = 20;
						if (
							sidebarTop < 0
								? touch0.clientY < scrollPad
								: touch0.clientY < sidebarTop + scrollPad
						) {
							if (sidebarTop < 0) {
								m.$window.scrollTop(wST + touch0.clientY - scrollPad);
							}
							else {
								m.$sidebar.scrollTop(m.$sidebar.scrollTop() + touch0.clientY - sidebarTop - scrollPad);
							}
						}
						else if (
							sidebarBottom > m.$window.outerHeight()
								? touch0.clientY > m.$window.outerHeight() - scrollPad
								: touch0.clientY > sidebarBottom - scrollPad
						) {
							if (sidebarBottom > m.$window.outerHeight()) {
								m.$window.scrollTop(wST + touch0.clientY - m.$window.outerHeight() + scrollPad);
							}
							else {
								m.$sidebar.scrollTop(m.$sidebar.scrollTop() + touch0.clientY - sidebarBottom + scrollPad);
							}
						}
						let tops = [];
						for (let i = 1; i < $catSiblings.length; i++) {
							tops.push(($catSiblings.eq(i - 1).offset().top - wST + $catSiblings.eq(i).offset().top - wST) / 2);
						}
						tops.push(($catSiblings.last().offset().top - wST + $lastSibling.offset().top + $lastSibling.outerHeight() - wST) / 2);
						let k = 0;
						for (; k < tops.length; k++) {
							if (touch0.clientY < tops[k]) {
								break;
							}
						}
						if (catTo !== k) {
							if (k < tops.length) {
								$catSiblings.eq(k).before($catTo);
							}
							else {
								$lastSibling.after($catTo);
							}
							catTo = k;
						}
					});
					m.mouseUpInEB = function (e: Event) {
						m.savedSidebarScrollTop = m.$sidebar.scrollTop();
						window.getSelection().removeAllRanges();
						e.preventDefault();
						e.stopPropagation();
						$catM.removeClass("move");
						$catM.css({ width: "auto", left: "unset", top: "unset" });
						$("#cat-to-here").replaceWith($catM);

						// 변경된 카테고리 목록을 문자열로 가져옴
						const newCatListStr = m.unescapeHTML(m.getCatListChanged());

						// userCatList 업데이트
						setUserCatList(m.escapeOnlyTag(newCatListStr));

						// 카테고리 데이터 업데이트
						setTimeout(async () => {
							await m.strCatListToJSON(newCatListStr, m.catList);

							setCatList([...m.catList]);

							// 스크롤 위치 복원
							setTimeout(() => {
								if (m.savedSidebarScrollTop !== undefined) {
									m.$sidebar.scrollTop(m.savedSidebarScrollTop);
								}
							}, 0);
						}, 0);

						m.$catList.find(".edit-bar").off("mouseup.mdInEB touchend.mdInEB");
						m.$html.off("mouseup.mdInEB touchend.mdInEB mousemove.mdInEB touchmove.mdInEB");
					};
					m.$catList.find(".edit-bar").on("mouseup.mdInEB touchend.mdInEB", m.mouseUpInEB);
					m.$html.on("mouseup.mdInEB touchend.mdInEB", m.mouseUpInEB);
				}
				else {
					// if $catSiblings doesn't exist.
					$catM.css({ "border-color": "rgb(230,120,120)" });
					m.$html.on("mousemove.mdInEB touchmove.mdInEB", function (e) {
						window.getSelection().removeAllRanges();
						e.preventDefault();
						e.stopPropagation();
					});
					m.$html.on("mouseup.mdInEB touchend.mdInEB", function (e) {
						m.$html.off("mouseup.mdInEB touchend.mdInEB mousemove.mdInEB touchmove.mdInEB");
						$catM.css({ "border-color": "" });
					});
				}
			});
		});
		m.change_catList_order_do = function (args, err) {
			return new Promise(async (resolve, reject) => {
				if (err) {
					args.$result?.html(err);
					reject(err);
				}
				m.catListHTMLEscaped = m.escapeOnlyTag(args.catListChanged.trim());
				if (m.myPage) {
					m.myCatListHTMLEscaped = m.catListHTMLEscaped;
					setMyCatList(m.catListHTMLEscaped);
				}
				setUserCatList(m.catListHTMLEscaped);
				await m.updateCatFS();
				await m.updateGotoCatsFS();

				// 스크롤 위치 복원
				setTimeout(() => {
					if (m.savedSidebarScrollTop !== undefined) {
						m.$sidebar.scrollTop(m.savedSidebarScrollTop);
					}
				}, m.wait);

				if (m.myPage) {
					$.ajax({
						type: "POST",
						url: "/changeOrders/CatList",
						data: args.catListChanged,
						dataType: "text",
					})
						.fail(function () {
							args.$result?.html("[--Changing CatList order has failed.--]");
							setTimeout(function () {
								args.$result?.html("");
							}, 5 * m.wait);
							reject("[--Changing CatList order has failed.--]");
						})
						.done(function (resp) {
							if (resp === "true") {
								args.$result?.html(`The order of catList is changed.`);
								setTimeout(function () {
									args.$result?.html("");
								}, 5 * m.wait);
								resolve(`The order of catList is changed.`);
							}
							else {
								args.$result?.html(`The order of catList is NOT changed. Some error may occur.`);
								setTimeout(function () {
									args.$result?.html("");
								}, 5 * m.wait);
								reject(`The order of catList is NOT changed. Some error may occur.`);
							}
						});
				}
				else {
					args.$result?.html(`This is not your page. The order is just temporarily changed.`);
					resolve(`This is not your page. The order is just temporarily changed.`);
					setTimeout(function () {
						args.$result?.html("");
					}, 5 * m.wait);
				}
			});
		};
		m.$change_catList_order_ok.on("click.change-order-catList", async function (e) {
			setIsChangingOrder(false);
			let $cats = m.$catList.find(".cat").not(`#cat-`);
			$cats.parent().removeClass("edit");
			$cats.find(".edit-bar").remove();
			let catListChanged = m.unescapeHTML(m.getCatListChanged().trim());
			if (catListChanged !== m.unescapeHTML(m.catListHTMLEscaped.trim())) {
				if (m.myPage) {
					m.rmb_me(m.change_catList_order_do, {
						catListChanged,
						$result: m.$catList_result,
					});
				}
				else {
					setUserCatList(m.escapeOnlyTag(catListChanged));
				}
				await m.reTriggerFS(m.fsGotoCats);
				await m.reTriggerFS(m.fsCat);
				await m.reTriggerFS(m.fsMRCat);

				// 스크롤 위치 복원
				setTimeout(() => {
					if (m.savedSidebarScrollTop !== undefined) {
						m.$sidebar.scrollTop(m.savedSidebarScrollTop);
					}
				}, 0);
			}
			else {
				// 스크롤 위치 복원
				setTimeout(() => {
					if (m.savedSidebarScrollTop !== undefined) {
						m.$sidebar.scrollTop(m.savedSidebarScrollTop);
					}
				}, 0);
			}
		});
		m.$change_catList_order_cancel.on("click.change-order-catList", async function (e) {
			setIsChangingOrder(false);
			let $cats = m.$catList.find(".cat").not(`#cat-`);
			$cats.parent().removeClass("edit");
			$cats.find(".edit-bar").remove();
			let dataCatListChanged = m.unescapeHTML(m.getCatListChanged().trim());
			let dataCatList = m.unescapeHTML(m.catListHTMLEscaped.trim());
			let selectedCat = null;

			if (dataCatListChanged !== dataCatList) {
				let $catSelected = m.$catList.find(".cat.selected").eq(0);
				if ($catSelected.length) {
					selectedCat = m.unescapeHTML($catSelected.find(".list-index-id").html());
				}
			}

			// 이전 카테고리 목록으로 복원
			setUserCatList(m.escapeOnlyTag(dataCatList));

			// 원래 순서로 카테고리 목록 재구성
			setTimeout(async () => {
				// 원래 카테고리 목록으로 데이터 재구성
				await m.strCatListToJSON(dataCatList, m.catList);

				// 선택된 카테고리 복원
				if (selectedCat) {
					$(`#cat-${m.escapeEncodePctg(encodeURIComponent(selectedCat))}`).addClass("selected");
				}
				else {
					$(`#cat-`).addClass("selected");
				}

				// 카테고리 목록 업데이트
				setCatList([...m.catList]);

				// 스크롤 위치 복원
				setTimeout(() => {
					if (m.savedSidebarScrollTop !== undefined) {
						m.$sidebar.scrollTop(m.savedSidebarScrollTop);
					}
				}, 0);
			}, m.wait);
		});

		m.$sidebar_dragger = $("#sidebar-dragger");
		m.$sidebar_toggle = $("#sidebar-toggle");
		m.$sidebar_dragger_in = $("#sidebar-dragger-in");
		m.$sidebar = $("#sidebar");
		m.$catList = $("#catList");
		m.$catList_result = $("#catList-result");
		m.$catList.on("mouseup.change-cat", m.handleChangeCat);

		m.updateCatFS = function () {
			return new Promise(async (resolve, reject) => {
				// * m.myCatList must be updated first.
				await m.strCatListToJSON(userCatList, m.catList);
				setCatList([...m.catList]);

				m.fsGotoCats.fullList.splice(0, m.fsGotoCats.fullList.length);
				let l = m.catList.length;
				for (let i = l - 1; i > 0; i--) {
					m.putCatToFSFullList(l - 1 - i, m.catList[i].cat, m.catList);
					// ! m.fsGotoCats 에 쓰임.
				}

				await m.strCatListToJSON(m.myCatListHTMLEscaped.trim() + "\n" + m.catListHTMLEscaped.trim() + "\n" + m.kipidCatListHTMLEscaped.trim(), m.myFSCatList);
				m.fsCat.fullList.splice(0, m.fsCat.fullList.length);
				m.fsMRCat.fullList.splice(0, m.fsMRCat.fullList.length);
				l = m.myFSCatList.length;
				for (let i = l - 1; i > 0; i--) {
					m.putCatToFSFullList(l - 1 - i, m.myFSCatList[i].cat, m.myFSCatList);
					// ! m.fsCat 과 m.fsMRCat 에 쓰임.
				}

				let cat = "";
				if (!m.fsCat.fullList[cat]) {
					m.fsCat.fullList[cat] = { i: m.fsCat.fullList.length, txt: m.splitHangul("Uncategorized"), cat, html: m.escapeOnlyTag("Uncategorized") };
					m.fsCat.fullList.push(m.fsCat.fullList[cat]);
				}
				if (!m.fsMRCat.fullList[cat]) {
					m.fsMRCat.fullList[cat] = { i: m.fsMRCat.fullList.length, txt: m.splitHangul("Uncategorized"), cat, html: m.escapeOnlyTag("Uncategorized") };
					m.fsMRCat.fullList.push(m.fsMRCat.fullList[cat]);
				}
				if (m.myPage) {
					if (!m.fsGotoCats.fullList[cat]) {
						m.fsGotoCats.fullList[cat] = { i: m.fsGotoCats.fullList.length, txt: m.splitHangul("Uncategorized"), cat, html: m.escapeOnlyTag("Uncategorized") };
						m.fsGotoCats.fullList.push(m.fsGotoCats.fullList[cat]);
					}
				}
				return resolve();
			});
		};

		m.updateGotoCatsFS = function () {
			return new Promise(async (resolve, reject) => {
				await m.strCatListToJSON(m.unescapeHTML(userCatList), m.catList);
				setCatList([...m.catList]);
				m.fsGotoCats.fullList.splice(0, m.fsGotoCats.fullList.length);
				let l = m.catList.length;
				for (let i = l - 1; i > 0; i--) {
					m.putCatToFSFullList(l - 1 - i, m.catList[i].cat, m.catList);
				}
				let i = l - 1;
				let cat = "";
				let fsFLCat = m.fsGotoCats.fullList[cat];
				if (fsFLCat) {
					m.fsGotoCats.fullList[i] = m.fsGotoCats.fullList[cat] = { ...fsFLCat, i, txt: m.splitHangul("Uncategorized"), cat, html: m.escapeOnlyTag("Uncategorized") };
				}
				else {
					fsFLCat =
						m.fsGotoCats.fullList[i] =
						m.fsGotoCats.fullList[cat] = { i, txt: m.splitHangul("Uncategorized"), cat, html: m.escapeOnlyTag("Uncategorized") };
				}
				return resolve();
			});
		};

		m.$sidebar_dragger_in.on("mousedown.sd touchstart.sd", function (e: Event) {
			let touch0 = e.type === "touchstart" ? (e as TouchEvent).touches[0] : (e as MouseEvent);
			let relativeX = touch0.clientX - Math.round(m.$sidebar_dragger.offset().left) + m.$window.scrollLeft();
			m.$html.on("mousemove.sd touchmove.sd", function (e: Event) {
				window.getSelection().removeAllRanges();
				e.preventDefault();
				e.stopPropagation();
				let touch0 = e.type === "touchmove" ? (e as TouchEvent).touches[0] : (e as MouseEvent);
				m.$sidebar.css({
					marginLeft: -m.$sidebar.outerWidth() + touch0.clientX - relativeX,
				});
				m.$sidebar_dragger.css({ left: touch0.clientX - relativeX });
				m.$html.on("mouseup.sd touchend.sd", function () {
					m.$html.off("mouseup.sd touchend.sd mousemove.sd touchmove.sd");
					if (touch0.clientX - relativeX > m.$sidebar.outerWidth() / 2) {
						m.$sidebar.css({ marginLeft: 0 });
						m.$sidebar_dragger.css({ left: m.$sidebar.outerWidth() });
						setOpened(draft => ({ value: true, count: draft.count + 1 }));
					} else {
						m.$sidebar.css({ marginLeft: -m.$sidebar.outerWidth() });
						m.$sidebar_dragger.css({ left: 0 });
						setOpened(draft => ({ value: false, count: draft.count + 1 }));
					}
				});
			});
		});
	}, []);

	useEffect(() => {
		(async () => {
			// console.log("userCatList in useEffect([myCatList, userCatList]):\n", userCatList);
			await m.strCatListToJSON(m.unescapeHTML(userCatList), m.catList);
			let cat = m.currentCat;
			while (cat = m.getSuperCat(cat)) {
				if (m.catList[cat]) {
					m.catList[cat].subCatExpanded = true;
				}
			}
			setCatList([...m.catList]);

			m.catListToHTML = function() {
				return new Promise(async (resolve) => {
					setCatList([...m.catList]);
					resolve();
				});
			};

			// ! m.myCatListHTMLEscaped 는 m.myFSCatList 를 위해 업데이트 필요!!!
			await m.strCatListToJSON(m.unescapeHTML(m.myCatListHTMLEscaped.trim()+"\n"+m.catListHTMLEscaped.trim()+"\n"+m.kipidCatListHTMLEscaped.trim()), m.myFSCatList);

			await m.updateCatFS();

			await m.updateGotoCatsFS();

			// try {
			// 	m.$change_catList_order_cancel.trigger("click.change-order-catList");
			// } catch (err) {
			// 	console.error(err);
			// }
		})();
	}, [myCatList, userCatList]);

	return (
		<aside id="sidebar" data-count={opened.count}>
			<div id="user-noti"></div>
			<div id="catList">
				<CatList
					catList={catList}
					fsGotoCats={m.fsGotoCats}
				/>
			</div>
			<div id="catList-result"></div>
			<div className="right">
				<div className={"button" + (!isChangingOrder ? "" : " none")} id="change-catList-order">Change orders</div>
				<div className={"button" + (isChangingOrder ? "" : " none")} id="change-catList-order-ok">OK</div>
				<div className={"button" + (isChangingOrder ? "" : " none")} id="change-catList-order-cancel">Cancel</div>
			</div>
		</aside>
	);
}
